module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-3-4"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("CHAPTER 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "89280.png",
      "src": "OEBPS/image/89280.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("It was good to sit down and relax with Ellie. When either of us needed to talk, she would wisely steer us to an area of the winery that provided more privacy. The gas fireplace was going, so we settled on a table near the warmth.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“So, have you heard from Carson since his New Year’s Eve visit?” I asked cautiously. Carson, a wine salesman, had captured Ellie’s heart before he decided to get divorced. Seeing Ellie so vulnerable was concerning, but she claimed to know what she was doing. She felt confident that he had truly filed for divorce.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I have!” she answered happily. “I think he’ll be back next weekend.” She paused before asking, “So, I take it you and Clark are out of sync again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That’s a good analysis,” I responded with a grin. “New Year’s Eve ended out of sync, actually.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“What do you mean by that?” Her face registered surprise. “You looked like you were having a good time!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("When I explained the chain of events of the evening and Clark using the L-word, her face went from joy to confusion. “Honestly, I don’t think the two of you will ever be on the same page. Timing is everything. When one is hot, the other is not.” Ellie shook her head in disbelief.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I guess you’re right,” I nodded. “Perhaps it will never happen. I think I’ve come to that conclusion and I may be okay with it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, aren’t you wise, my friend,” Ellie teased as she filled my wine glass. “Now, let’s enjoy this food!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Like always, we laughed and gossiped as Trout, the bartender, added his two cents worth once in a while. Before I left, I purchased bottles of wine for Carla and Maggie and some to have in my condo. This visit was just what I needed before leaving Borna.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Coming back to the guest house, I marveled at all the changes that had happened since I moved here. Actually it was Clark who first suggested that I turn my home into a guest house. Borna had no place for people to stay. When I added a large sunporch to the house, he said it would be perfect for guests and an excuse for me to bake my blueberry muffins. I talked it over with Ellie and the guest house became a reality. It also gave purpose to my life in Borna. For now, I went up to my bedroom suite and finished packing.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("My house had been adapted to include one guest room on the first floor that was once Doc’s office. I called that room The Study. On the second floor were my suite, a bedroom called the Wildflower Room, and another called the Forest Room. The third floor was named Josephine’s Attic Suite, which was sizable and had a nice view of Main Street. I liked to think I was living here alone in the house, but I knew there was a spirit of some kind, which I had assumed was Josephine. I felt a connection to her when I found a disturbing quilt left in the house that she had made. The more I learned about Josephine, the more I didn’t know. For some reason, however, I felt connected to her. Doc Paulson and his wife had no children. It was rumored that Doc drank too much and chewed tobacco even as he was seeing his patients. People recall never seeing Josephine when they saw Doc, so Ellie and I assumed she spent a great deal of time in the attic. I was continuing to research her life in little bits and pieces. The Heritage Museum in Dresden was somewhat helpful, but there didn’t seem to be a single picture of her anywhere. How odd, I thought.")]), _c('span', {
    staticClass: "byline"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b372b99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/everlastingquilts_split6.vue
// module id = 78
// module chunks = 0